// FOCO MUSCULAR — 12-prompt-objetivo-vita.md § 3 (linha StepInterest).
//
// O step era "o que te interessa mais no app?" (4 opções) e virou o mapa de
// foco muscular, como o handoff manda. Duas verificações antes de trocar:
//
//  1. `INTEREST` não é LIDO em lugar nenhum — nem no app, nem nas functions.
//     O `saveUserObjective` guarda o blob de respostas inteiro e ninguém
//     consome esse campo. Então gravar uma LISTA nele, como o § 3 autoriza
//     ("salvar em INTEREST como lista ou omitir — não inventar endpoint"),
//     não quebra consumidor nenhum.
//  2. O auto-advance: este step está em `AUTO_ADVANCE_STEPS` e com seleção
//     múltipla ele avançaria no primeiro toque. A saída é `setNeedsButton(true)`
//     — a alavanca que JÁ existe para isso. `AUTO_ADVANCE_STEPS` não foi tocado.
//
// O MAPA é o MESMO da aba Treino (`variant="select"`, o que a tela "Gerar
// treino" usa): mesmo SVG, mesmos ids, mesma paleta de seleção. Nada de um
// segundo mapa só para o onboarding.
//
// "Sem preferência" grava lista VAZIA, que é a resposta honesta para "monta o
// equilíbrio pra mim" — e é diferente de não ter respondido.

import React, { useCallback, useEffect, useState } from "react";

import MuscleMap from "../../treinos/components/muscle-map/MuscleMap.jsx";
import { MUSCULOS } from "../conversa.js";
import { Chips, LinkSuave } from "../widgets/Widgets.jsx";
import s from "./StepInterest.module.scss";

const StepInterest = ({ setCanProceed, setStepData, setNeedsButton }) => {
  const [grupos, setGrupos] = useState([]);
  const [semPreferencia, setSemPreferencia] = useState(false);

  // Seleção múltipla pede botão: sem isto o auto-advance dispararia no
  // primeiro músculo tocado.
  useEffect(() => {
    setNeedsButton?.(true);
    return () => setNeedsButton?.(false);
  }, [setNeedsButton]);

  useEffect(() => {
    const valido = semPreferencia || grupos.length > 0;
    setCanProceed(valido);
    setStepData(valido ? { INTEREST: semPreferencia ? [] : grupos } : null);
  }, [grupos, semPreferencia, setCanProceed, setStepData]);

  const alternar = useCallback((_chave, proximo) => {
    setSemPreferencia(false);
    setGrupos(proximo);
  }, []);

  return (
    <div className={s.foco}>
      <div className={s.mapa}>
        <MuscleMap
          view="both"
          variant="select"
          dualColumn
          selectable
          selected={grupos}
          onToggleMuscle={alternar}
          showLabels={false}
          showLegend={false}
        />
      </div>

      {/* Os chips repetem a seleção em texto: no mapa, um grupo pequeno
          aceso é fácil de perder, e é por aqui que se desmarca sem mirar. */}
      {grupos.length > 0 && (
        <Chips
          opcoes={grupos.map((g) => ({ value: g, label: MUSCULOS[g] || g }))}
          valores={grupos}
          onToggle={(g) => setGrupos((atual) => atual.filter((x) => x !== g))}
        />
      )}

      <LinkSuave
        ativo={semPreferencia}
        onClick={() => {
          setSemPreferencia((v) => !v);
          setGrupos([]);
        }}
      >
        Sem preferência, monta o equilíbrio pra mim
      </LinkSuave>
    </div>
  );
};

export default StepInterest;
